'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//

var animation = weex.requireModule('animation');
var icon = require('../setting/icon.base64.js');
// const modal = weex.requireModule('modal');
exports.default = {
  props: {
    // 是否选中
    iconOn: {
      type: String,
      default: icon['smart_ic_switch_l@2x']
    },
    iconOff: {
      type: String,
      default: icon['smart_ic_switch_l@2x']
    },
    width: {
      type: String,
      default: '106'
    },
    height: {
      type: String,
      default: '48'
    },
    checked: {
      type: Boolean,
      default: false
    }

  },
  computed: {
    icon: function icon() {
      return this.isChecked ? this.iconOn : this.iconOff;
    }
  },
  data: function data() {
    return {
      isChecked: false
    };
  },

  watch: {
    checked: function checked() {
      this.isChecked = this.checked;
      this.updateIcon();
    }
  },
  methods: {
    switchValue: function switchValue(value) {
      if (value !== undefined) {
        this.isChecked = value;
        this.updateIcon();
      } else {
        this.onchange();
      }
    },
    onSwipe: function onSwipe(event) {
      if (this.isChecked && event.direction === 'left') {
        this.onchange();
      } else if (!this.isChecked && event.direction === 'right') {
        this.onchange();
      }
    },
    onchange: function onchange() {
      this.isChecked = !this.isChecked;
      this.updateIcon();

      this.$emit('change', { value: this.isChecked });
    },
    updateIcon: function updateIcon() {
      var durationTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;

      var switchBar = this.$refs.switchBar;
      if (this.isChecked) {
        animation.transition(switchBar, {
          styles: {
            transform: 'translateX(0px)'
          },
          duration: durationTime, // ms
          timingFunction: 'linear',
          delay: 0 // ms
        }, function () {});
      } else {
        animation.transition(switchBar, {
          styles: {
            transform: 'translateX(' + -(this.width - this.height + 4) + 'px)'
          },
          duration: durationTime, // ms
          timingFunction: 'linear',
          delay: 0 // ms
        }, function () {});
      }
    }
  },
  mounted: function mounted() {
    this.updateIcon(0);
  },
  created: function created() {
    this.isChecked = this.checked;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-switch-bar/index.vue
// module id = 401
// module chunks = 0 1